import React from 'react';

import Details from '../../components/Details/detail';

export default function OrderDetails(props) {
  return <Details documentation={true} {...props} />;
}
